export const sanitizePageHtml = (html) => {
  let cleanHtml = String(html || '');
  
  // 1. Aggressively strip any script tag containing these S3/Greta domains
  cleanHtml = cleanHtml.replace(/<script[^>]*?(?:greta-scripts|greta-preview|quest-public-files|inspector-dark|runtime-instrumentation)[^>]*?>[\s\S]*?<\/script>/gi, '');
  cleanHtml = cleanHtml.replace(/<script>\s*window\.addEventListener\("load"[\s\S]*?IFRAME_LOADED[\s\S]*?<\/script>/gi, '');
  
  // 2. Strip Google Fonts API calls to enforce local font usage
  cleanHtml = cleanHtml.replace(/<link[^>]*fonts\.(?:googleapis|gstatic)\.com[^>]*>/gi, '');
  
  return cleanHtml;
};